import styled from "styled-components";

export const Centered = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
